import config from 'config'
import fetch from 'isomorphic-fetch'
import qs from 'qs'
import { processURLAddress } from '@vue-storefront/core/helpers'
import rootStore from '@vue-storefront/core/store'

const getEndpoint = (): string => {
  return (config.netsuite && config.netsuite.endpoint) || 'https://lbpprodata.luxbp.com'
}

export const getAuthToken = (): string | null => {
  return rootStore.getters['user/getUserToken'] || null
}

export const netsuiteFetch = async (
  path: string,
  options: RequestInit = {},
  query?: Record<string, any>
): Promise<any> => {
  const token = getAuthToken()
  if (!token) {
    throw new Error('Not authenticated')
  }

  let url = `${processURLAddress(getEndpoint())}${path}`
  if (query && Object.keys(query).length) {
    url += `?${qs.stringify(query, { arrayFormat: 'comma' })}`
  }

  const response = await fetch(url, {
    ...options,
    mode: 'cors',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {})
    }
  })

  const json = await response.json().catch(() => ({}))

  if (!response.ok) {
    const message = (json && json.error) || response.statusText || 'Request failed'
    const error: any = new Error(message)
    error.status = response.status
    error.body = json
    throw error
  }

  return json
}
